import styled from 'styled-components';
import { RouterLink } from '@redux-first-router-link';
import { VisuallyHidden } from '@simplywallst/ui-core/src/theme/utils';

export const HiddenText = styled('span')`
  ${VisuallyHidden}
`;

export const StyledRouterLink = styled(RouterLink)`
  width: 100%;
`;
